import {
  Code as MantineCode,
  CodeProps as MantineCodeProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './Code.module.css';

export type CodeProps = Omit<
  MantineCodeProps,
  'color' | 'styles' | 'classNames' | 'style'
>;

const classNames = {
  root: styles.root,
};

export const Code = forwardRef<HTMLElement, CodeProps>(({ ...props }, ref) => {
  return <MantineCode ref={ref} unstyled classNames={classNames} {...props} />;
});

Code.displayName = 'Code';
